import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8 border-t border-dark-surface" data-id="element-23">
      <div className="max-w-3xl mx-auto text-center" data-id="element-24">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-8 uppercase" data-id="element-25">
          El lunes que viene{' '}
          <span className="text-brand-orange" data-id="element-26">va a llegar igual</span>
        </h2>
        <div className="font-inter text-lg md:text-xl text-gray-300 space-y-6 leading-relaxed mb-10" data-id="element-27">
          <p data-id="element-28">
            La diferencia es si ese lunes te mirás al espejo con el mismo
            resultado de siempre, o con 7 días del protocolo ya encima.
          </p>
          <p className="text-white font-semibold text-xl md:text-2xl" data-id="element-29">
            A $6.39 no es una decisión financiera. Es una decisión de si seguís
            haciendo lo mismo esperando resultados distintos.
          </p>
        </div>

        <CTAButton className="text-2xl py-5" data-id="element-30">
          👉 DESCARGAR CERO PANZA 14 — $6.39
        </CTAButton>

        <p className="font-inter text-sm text-gray-500 mt-6" data-id="element-31">
          Acceso inmediato · Garantía 7 días · Un solo pago
        </p>
      </div>
    </section>;
}